module.exports = __webpack_public_path__ + "static/img/xsdclogo.751e141.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/xsdclogo.png
// module id = eB3P
// module chunks = 1